import { LANGUAGE } from "./constants";
export default {
	[LANGUAGE]: (state, payload) => (state.lang = payload)
};
